// @ts-nocheck 45b23499
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_googlemap'],
      sections: [
        addPanel.sections.getSections().contact.googleMapsDesignPanelSection,
      ],
    };
  },
};
